<app-filter-panel [numberOfResults]="numberOfResults" [activeFilterCount]="activeFilterCount"
  (apply)="onApply()" (cancel)="onCancel()">

  <!-- Event Type -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "EVENT_TYPE" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let eventLogNumber of eventLogNumbers">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-eventlog-' + eventLogNumber">
            <input type="checkbox" [id]="'checkbox-eventlog-' + eventLogNumber"
              [checked]="draftEventLogNumbers.includes(eventLogNumber)"
              (change)="toggle(eventLogNumber)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-eventlog-' + eventLogNumber">{{ "EVENTLOG_TYPE_" + eventLogNumber | translate }}</label>
        </div>
      </div>
    </div>
  </div>

</app-filter-panel>
